import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-content',
  standalone: true,
  host: {
    class: 'block min-h-0 overflow-auto px-6 py-4',
  },
  template: `<ng-content />`,
})
export class DialogContentComponent {}
